import { FC, ReactNode } from 'react';
import { LogoIcon } from '@src/svg';

type VerificationCodeLayoutProps = {
  children: ReactNode;
};

export const VerificationCodeLayout: FC<VerificationCodeLayoutProps> = ({
  children,
}) => {
  return (
    <div className="verification-code">
      <div className="verification-code__logo">
        <LogoIcon />
      </div>
      {children}
    </div>
  );
};
